<template>
  <vx-card no-shadow>
    <!-- Img Row -->
    <div class="flex flex-wrap items-center mb-base">
      <vs-avatar :src="activeUserInfo.photoURL" size="70px" class="mr-4 mb-4" />
      <div>
        <vs-button :color="logo.type" class="mr-4 sm:mb-0 mb-2">
          <label class="flex flex-col items-centercursor-pointer hover:bg-blue hover:text-white">
            <span class="text-base leading-normal">{{ logo.text }}</span>
            <input type="file" id="file" ref="file" v-on:change="handleFileUpload(true)" class="hidden" />
          </label>
        </vs-button>
        <vs-button type="border" color="danger" @click="handleFileUpload(false)">Remove</vs-button>
        <p class="text-sm mt-2">Allowed JPG, GIF or PNG. Max size of 800kB</p>
      </div>
    </div>

    <!-- Info -->
    <vs-input class="w-full mb-base" ty label-placeholder="Username" v-model="username"></vs-input>
    <vs-input class="w-full" label-placeholder="Name" v-model="name"></vs-input>

    <vs-alert v-if="emailVerify" icon-pack="feather" icon="icon-info" class="h-full my-4" color="warning">
      <p>Your account is not verified. <span class="hover:underline cursor-pointer text-primary" @click="resendConfirmation()">Resend Confirmation</span></p>
    </vs-alert>

    <vs-input class="w-full my-base" label-placeholder="Email" v-model="email"></vs-input>
    <vs-input class="w-full my-base" label-placeholder="Company" v-model="company"></vs-input>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="passwordPopup()">Save Changes</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
    </div>

    <!--Popup used for password reconfermation //change email-->
    <vs-popup class="text-center" background-color="rgba(0,0,0,0.5)" title="Password Confirmation" :active.sync="passwordPopupToggle">
      <p>Please review your changes before proceeding</p>
      <p class="my-2">Username: {{ username }}</p>
      <p class="my-2">Name: {{ name }}</p>
      <p class="my-2">Email: {{ email }}</p>
      <p class="my-2">Company: {{ company }}</p>
      <vs-input v-model="passwordConf" type="password" placeholder="Password" class="w-full mb-4" />
      <vs-button color="danger" type="filled" @click="save()">Continue</vs-button>
      <vs-button color="success" type="filled" @click="passwordPopup()" class="m-2">Cancel</vs-button>
    </vs-popup>
  </vx-card>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/storage'
const user = firebase.auth().currentUser

export default {
  data() {
    return {
      logo: { imageUrl: null, type: 'primary', text: 'Upload photo' },
      username: this.$store.state.AppActiveUser.name,
      name: this.$store.state.AppActiveUser.displayName,
      email: this.$store.state.AppActiveUser.email,
      originalEmail: this.$store.state.AppActiveUser.email,
      photoURL: this.$store.state.AppActiveUser.photoURL,
      company: this.$store.state.AppActiveUser.company,
      passwordPopupToggle: false,
      passwordConf: '',
      emailVerify: !user.emailVerified,
    }
  },
  methods: {
    handleFileUpload(func) {
      if (func === true) this.logo = { imageUrl: this.$refs.file.files[0], type: 'success', text: 'Uploaded' }
      else this.logo = { imageUrl: null, type: 'primary', text: 'Upload photo' }
    },
    async resendConfirmation() {
      if (!user.emailVerified) {
        try {
          await user.sendEmailVerification()
          this.$rollbar.info('Email Verirfication sent successfully', { data: {} })
          this.$vs.notify({
            title: 'Email Verification Sent.',
            text: 'Please Check Your Email.',
            color: 'success',
            icon: 'check_box',
          })
        } catch (error) {
          this.$rollbar.error('Email Verification Sent Failed', { error, data: error.message })
          this.$vs.notify({
            time: 4000,
            title: 'Email Verification Sent Failed',
            text: error.message,
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
          })
        }
      }
    },
    async save() {
      try {
        this.passwordPopupToggle = false
        this.$vs.loading({
          type: 'corners',
        })

        //prepare credentials of user. This will be used to reaunthenticate the user
        const credential = firebase.auth.EmailAuthProvider.credential(firebase.auth().currentUser.email, this.passwordConf)
        //this is used to reauthenticate the user
        await user.reauthenticateWithCredential(credential)

        //need to reset local password field that we used to reauth to ensure safty
        this.passwordConf = ''

        const data = { user: { name: this.name, username: this.username, email: this.email, company: this.company } }
        const localStorageData = {
          displayName: this.name,
          name: this.username,
          email: this.email,
          company: this.company,
        }
        if (this.logo.imageUrl) {
          const storageRef = firebase.storage().ref()
          const imageRef = storageRef.child(`userLogo/${this.logo.imageUrl.name}`)
          await imageRef.put(this.logo.imageUrl)
          const downloadURL = await imageRef.getDownloadURL()
          data.user.logo = downloadURL
          localStorage.photoURL = downloadURL
        }

        //check if the new email entered !== the existing email
        if (this.$store.state.AppActiveUser.email !== this.email) {
          //update firebase authentication
          await user
            .updateEmail(`${this.email}`)
            .then(async () => {
              // update firestore
              // eslint-disable-next-line no-unused-vars
              const path = await firebase
                .firestore()
                .collection('cloudify')
                .doc(JSON.parse(localStorage.getItem('userInfo')).uid)
                .set(data, { merge: true })
            })
            .then(() => {
              //show the notification for success
              this.$store.commit('UPDATE_USER_INFO', localStorageData)
              this.$vs.loading.close()
              this.$vs.notify({
                color: 'success',
                title: 'User Info',
                text: 'User info updated successfully',
              })
            })
        } else {
          // eslint-disable-next-line no-unused-vars
          const path = await firebase
            .firestore()
            .collection('cloudify')
            .doc(JSON.parse(localStorage.getItem('userInfo')).uid)
            .set(data, { merge: true })
          this.$store.commit('UPDATE_USER_INFO', localStorageData)
          this.$vs.loading.close()
          this.$vs.notify({
            color: 'success',
            title: 'User Info',
            text: 'User info updated successfully',
          })
        }
      } catch (err) {
        //need to reset local password field that we used to reauth to ensure safty
        this.passwordConf = ''
        //if during any process of changing the user information an error occurs this catch block will handle it.
        this.$vs.loading.close()
        this.$vs.notify({
          color: 'danger',
          title: 'Error Occured',
          text: `${err.code}`,
        })
      }
    },
    //this function shows a pop up for user to enter password to confirm his changes
    passwordPopup() {
      if (this.$store.state.admin.access && this.originalEmail !== this.email) {
        this.$vs.notify({
          color: 'warning',
          title: 'Admin Access',
          text: 'Admin accounts cannot change email of client',
        })
      } else {
        this.passwordPopupToggle = !this.passwordPopupToggle
      }
    },
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
  },
}
</script>

<style scoped>
.center {
  text-align: center;
}
</style>
